import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import Spacer from 'design-system/Spacer';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
import { formatAmount, formatPlural } from 'utils/formatting';
import { useCurrentPrice } from '../hooks/selectors';
export const BuyLimitOrderModalContent = ({ symbol, assetId, quantity }) => {
    const currentPrice = useCurrentPrice(assetId);
    const handleOk = useCallback(() => {
        Modal.hide();
    }, []);
    return (<View style={styles.contentContainer}>
      <Spacer h={16}/>
      <Text TextThin-14 Secondary centered>
        {`You are placing a good for day limit order to buy ${quantity} ${formatPlural('share', 'shares', quantity)} of $${symbol}. Your pending order, if executed, will execute at a limit price of ${formatAmount(currentPrice ? currentPrice.value * 1.05 : 0, currentPrice?.currency, 2)} per share or better. The limit price is set at 5% above the last traded price.`}
      </Text>
      <Spacer h={32}/>
      <Button brand title="OK" onPress={handleOk}/>
    </View>);
};
const BuyLimitOrderModal = {
    show: (symbol, assetId, quantity) => {
        Modal.show(<BuyLimitOrderModalContent assetId={assetId} symbol={symbol} quantity={quantity}/>, {
            title: 'Limit order',
            containerStyle: styles.modal,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    contentContainer: {
        paddingHorizontal: rem(16),
    },
});
export default BuyLimitOrderModal;
